import { useEffect, useState } from "react";
import Maintenance from "../components/frontPage_components/maintenance/Maintenance";
import Search from "../components/frontPage_components/search/Search";
import {
  fetchSimDocumentsToken,
  fetchSimToken,
} from "../authentication/AuthenticationHelper";
import { jwtDecode } from "jwt-decode";
import LoginError from "../components/login_components/LoginError";
import { Spinner } from "react-bootstrap";
export default function FrontPage() {
  const [isAdvancedUser, setIsAdvancedUser] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState<boolean>(false);
  const [loadPage, setLoadPage] = useState<boolean>(true);

  useEffect(() => {
    const fetchTokenWithRetry = async (retries = 1) => {
      try {
        const simToken = await fetchSimToken();
        const simDocumentsToken = await fetchSimDocumentsToken();

        const simDecoded: any = jwtDecode(simToken || "");
        const simDocumentsDecoded: any = jwtDecode(simDocumentsToken || "");

        const simRoles = simDecoded?.roles || [];
        const simDocumentsRoles = simDocumentsDecoded?.roles || [];

        if (simDocumentsRoles.includes("AdvancedUser")) {
          setIsAdvancedUser(true);
        }

        if (simRoles.length > 0 && simDocumentsRoles.length > 0) {
          setIsAuthorized(true);
        }
      } catch (error) {
        if (retries > 0) {
          await fetchTokenWithRetry(retries - 1);
        } else {
          setIsAuthorized(false);
        }
      } finally {
        setLoadPage(false);
      }
    };

    fetchTokenWithRetry(1); // 1 retry allowed
  }, []);

  return loadPage ? (
    <center>
      <Spinner className="align-center" />
    </center>
  ) : isAuthorized ? (
    <>
      {isAdvancedUser && <Maintenance />}
      <Search />
    </>
  ) : (
    <LoginError />
  );
}
